<template>
    <v-list-item class="myprovet_categories_list" :data-cy="title == 'Corporate' ? 'sidebar-corporate-btn' : 'sidebar-btn'" :dense="small" @click="$emit('selected-category', $event)">
        <!-- Layout only for an expanded main category -->
        <!-- Surrounds content in a new div to format the background for this entire inner row correctly -->
        <div v-if="!small && expanded" :style="categoryHeight" class="main-category">
            <v-list-item-icon v-if="icon" class="active-category-content responsive-icon">
                <v-icon :class="iconSize" class="btn-bg-color-blue dark-blue-color" v-text="icon"></v-icon>
            </v-list-item-icon>

            <v-list-item-content :class="expanded ? 'active-category' : ''">
                <v-list-item-title
                    class="dark-blue-color"
                    :class="[
                        {
                            'subcategory-active': active,
                        },
                        active ? categoryResponsive : inactiveCategoryResponsive,
                    ]"
                    v-text="tb(title)"
                ></v-list-item-title>
            </v-list-item-content>

            <v-list-item-icon v-if="(!active && small) || !small" class="active-category-content">
                <v-icon class="btn-bg-color-blue dark-blue-color" :class="!small ? iconSize : 'small-button-rounded'">
                    {{ expanded ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
                </v-icon>
            </v-list-item-icon>
        </div>

        <!-- Layout for non-expanded main categories and sub categories -->
        <template v-else>
            <v-list-item-icon v-if="icon" class="responsive-icon">
                <v-icon :class="iconSize" class="btn-bg-color-blue dark-blue-color" v-text="icon"></v-icon>
            </v-list-item-icon>

            <v-list-item-content v-if="small" :class="active ? activeFillerContentResponsive : inactiveFillerContentResponsive"> </v-list-item-content>

            <v-list-item-content :class="active && small ? 'active-list-item-content' : ''">
                <v-list-item-title
                    class="dark-blue-color"
                    :class="[
                        {
                            'tabbed-subcategory sidebar-responsive-text': small,
                            'subcategory-active': active && small,
                            'active-category': active && !small && expanded,
                        },
                        !small ? inactiveCategoryResponsive : '',
                    ]"
                    :data-cy="title == 'Logistica Sustentável' ? 'sidebar-corporate-logistics-link-inner' : ''"
                    v-text="tb(title)"
                ></v-list-item-title>
            </v-list-item-content>

            <v-list-item-icon v-if="(!active && small) || !small">
                <v-icon class="btn-bg-color-blue dark-blue-color" :class="!small ? iconSize : 'small-button-rounded'">
                    {{ expanded ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
                </v-icon>
            </v-list-item-icon>
        </template>
    </v-list-item>
</template>

<script>
export default {
    props: {
        title: String,
        icon: String,

        active: {
            type: Boolean,
            default: false,
        },

        expanded: {
            type: Boolean,
            default: false,
        },

        classes: {
            type: String,
            default: 'px-0',
        },

        small: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        iconSize() {
            switch (this.$vuetify.breakpoint.name) {
            case 'xs':
            case 'lg':
                return 'appbar-icon-button-medium';
            case 'sm':
            case 'md':
            case 'xl':
            default:
                return 'appbar-icon-button';
            }
        },

        categoryHeight() {
            switch (this.$vuetify.breakpoint.name) {
            case 'xs':
            case 'lg':
                return 'max-height: 35px';
            case 'sm':
            case 'md':
            case 'xl':
            default:
                return 'max-height: 40px';
            }
        },

        categoryResponsive() {
            switch (this.$vuetify.breakpoint.name) {
            case 'xs':
            case 'lg':
                return 'active-category-lg';
            case 'sm':
            case 'md':
            case 'xl':
            default:
                return 'active-category-xl';
            }
        },

        inactiveCategoryResponsive() {
            switch (this.$vuetify.breakpoint.name) {
            case 'xs':
            case 'lg':
                return 'inactive-category-lg';
            case 'sm':
            case 'md':
            case 'xl':
            default:
                return 'inactive-category-xl';
            }
        },

        activeFillerContentResponsive() {
            switch (this.$vuetify.breakpoint.name) {
            case 'xs':
            case 'lg':
                return 'left-filler-active-lg';
            case 'sm':
            case 'md':
            case 'xl':
            default:
                return 'left-filler-active-xl';
            }
        },

        inactiveFillerContentResponsive() {
            switch (this.$vuetify.breakpoint.name) {
            case 'xs':
            case 'lg':
                return 'left-filler-content-lg';
            case 'sm':
            case 'md':
            case 'xl':
            default:
                return 'left-filler-content-xl';
            }
        },
    },
};
</script>

<style scoped>
.myprovet_categories_list {
    padding-left: 16px !important;
    padding-right: 16px !important;
    margin-left: -16px;
    margin-right: -16px;
}

.myprovet_categories_list:hover {
    box-shadow: inset 2px 0px 0px 0px #006DB6;
    /*#154579*/
}

.active-category-content {
    margin-bottom: 0px;
    margin-top: 0px;
    align-items: center;
    align-self: center;
    display: flex;
    flex-wrap: wrap;
}

.small-button-rounded {
    border-radius: 8px;
}

.subcategory-active {
    padding-top: 7px;
    padding-bottom: 5px;
    padding-left: 7px;
    background-clip: border-box;
    border-radius: 8px;
    font-weight: 900 !important;
}

.main-category {
    display: flex;
    flex: 1 1 100%;
    margin-top: 16px;
    margin-bottom: 16px;
    background-color: #e9f7fd !important;
    background-clip: border-box;
    border-radius: 8px;
    padding-left: 0px;
    padding-right: 0px;
    font-weight: 900 !important;
}

.active-category-xl {
    max-height: 40px;
    background-color: #e9f7fd !important;
    font-weight: 900 !important;
    font-size: 0.875rem;
    padding-left: 0px;
    padding-right: 0px;
}

.inactive-category-xl {
    max-height: 40px;
    font-size: 0.875rem;
    padding-left: 0px;
    padding-right: 0px;
}

.active-category-lg {
    max-height: 35px;
    background-color: #e9f7fd !important;
    font-weight: 900 !important;
    font-size: 0.875rem;
    padding-left: 0px;
    padding-right: 0px;
}

.inactive-category-lg {
    max-height: 35px;
    font-size: 0.875rem;
    padding-left: 0px;
    padding-right: 0px;
}

.active-list-item-content {
    background-color: #e9f7fd !important;
    padding-bottom: 2px;
    padding-top: 2px;
    border-radius: 8px;
}

.active-subcategory-text {
    font-weight: 900 !important;
}

.sidebar-responsive-text {
    font-size: 0.75rem;
}

.left-filler-content-xl {
    width: 73px;
    min-width: 73px;
    max-width: 73px;
}

.left-filler-active-xl {
    width: 65px;
    min-width: 65px;
    max-width: 65px;
}

.left-filler-content-lg {
    width: 68px;
    min-width: 68px;
    max-width: 68px;
}

.left-filler-active-lg {
    width: 60px;
    min-width: 60px;
    max-width: 60px;
}

/*
@media only screen and (max-width: 1399px) {
    .left-filler-content {
        width: 57px;
        min-width: 57px;
        max-width: 57px;
    }

    .left-filler-active {
        width: 49px;
        min-width: 49px;
        max-width: 49px;
    }

    .responsive-icon {
        margin-right: 16px !important;
    }
}

@media only screen and (min-width: 1400px) {
    .left-filler-content {
        width: 73px;
        min-width: 73px;
        max-width: 73px;
    }

    .left-filler-active {
        width: 65px;
        min-width: 65px;
        max-width: 65px;
    }
} */
</style>
